import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # DeptRestructureMap
 *
 * 조직 개편 전후 부서 매핑 모델 (TB_DEPT_RESTRUCTURE_MAP)
 */
export const DeptRestructureMap = types
  .model('DeptRestructureMap')
  // --------------------------------------------------------------------------
  .props({
    mapSid: types.optional(types.number, 0),
    restructureSid: types.optional(types.number, 0),
    sourceDeptSid: types.optional(types.number, 0),
    targetDeptSid: types.optional(types.number, 0),
    dataWeightPct: types.optional(types.number, 100),
    sourceDeptNm: types.optional(types.string, ''),
    targetDeptNm: types.optional(types.string, ''),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  .actions((self) => ({
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDeptRestructureMap;
      (Object.keys(newProps) as TDeptRestructureMapKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDeptRestructureMap = Instance<typeof DeptRestructureMap>;
type TDeptRestructureMapSnapshot = SnapshotOut<typeof DeptRestructureMap>;

export interface IDeptRestructureMap extends TDeptRestructureMap {}
export type TDeptRestructureMapKeys = keyof TDeptRestructureMapSnapshot & string;
export interface IDeptRestructureMapSnapshot extends TDeptRestructureMapSnapshot {}
export const createDeptRestructureMap = () =>
  types.optional(DeptRestructureMap, {} as TDeptRestructureMap);
